import {
  TableContainer,
  Table,
  Paper,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Box,
  Collapse,
  TextField,
  Button,
} from "@mui/material";
import { useMutation, useQuery } from "@apollo/client";
import IconButton from "@mui/material/IconButton";
import {
  GET_COURSE_SUGGESTIONS,
  RESOLVE_COURSE_SUGGESTION,
} from "pages/courseSuggestions/courseSuggestionQueries";
import { format } from "date-fns";
import React, { useState } from "react";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import { showErrorToast, showSuccessToast } from "toast-service";

const SuggestionTableRow = ({ row, isDuplicate }) => {
  const [open, setOpen] = useState(false);
  const [comment, setComment] = useState("");

  const [resolveCourseSuggestion] = useMutation(RESOLVE_COURSE_SUGGESTION, {
    onCompleted: () => {
      setComment("");
      showSuccessToast("Kursvorschlag wurde bearbeitet");
    },
    onError: (error) => {
      showErrorToast("Fehler beim Bearbeiten des Kursvorschlags");
    },
    refetchQueries: [{ query: GET_COURSE_SUGGESTIONS }],
    awaitRefetchQueries: true,
  });

  const handleAccept = async () => {
    await resolveCourseSuggestion({
      variables: {
        _id: row._id,
        isAccepted: true,
        resolvingComment: comment,
      },
    });
  };

  const handleReject = async () => {
    await resolveCourseSuggestion({
      variables: {
        _id: row._id,
        isAccepted: false,
        resolvingComment: comment,
      },
    });
  };

  return (
    <>
      <TableRow
        key={row._id}
        sx={{
          "&:last-child td, &:last-child th": { border: 0 },
          background: isDuplicate ? "lightgrey" : "white",
        }}
      >
        <TableCell>
          {isDuplicate ? (
            <p>DUPLIKAT</p>
          ) : (
            <IconButton
              aria-label="expand row"
              size="small"
              onClick={() => setOpen(!open)}
            >
              {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
            </IconButton>
          )}
        </TableCell>
        <TableCell component="th" scope="row">
          {row.title}
        </TableCell>
        <TableCell>{row.university}</TableCell>
        <TableCell align="right">{row.suggestedBy?.username}</TableCell>
        <TableCell align="right">
          {format(new Date(parseInt(row.createdAt)), "dd/MM/yyyy HH:mm")}
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell
          style={{
            paddingBottom: 0,
            paddingTop: 0,
            background: "grey",
            width: "100%",
            height: "100%",
          }}
          colSpan={6}
          value={comment}
          onChange={(e) => setComment(e.target.value)}
        >
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box
              sx={{
                width: "100%",
                height: "100%",
                display: "flex",
                justifyContent: "space-around",
                alignItems: "center",
              }}
            >
              <Box>
                <Button
                  variant="contained"
                  color={"primary"}
                  sx={{
                    p: 1,
                    m: 1,
                  }}
                  onClick={handleAccept}
                >
                  Accept Course suggestion
                </Button>
                <Button
                  variant="contained"
                  color={"warning"}
                  sx={{
                    p: 1,
                    m: 1,
                  }}
                  onClick={handleReject}
                >
                  Decline Course suggestion
                </Button>
              </Box>
              <TextField
                id="outlined-multiline-static"
                multiline
                rows={4}
                placeholder="Editors comment"
                sx={{ width: "40%", p: 2 }}
              />
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </>
  );
};

export const NewCourseSuggestionsPage = () => {
  const { data: courseSuggestionsData, loading: isLoadingCourseSuggestions } =
    useQuery(GET_COURSE_SUGGESTIONS, { pollInterval: 5000 });

  if (isLoadingCourseSuggestions) {
    return <p>Loading</p>;
  }

  const latestUniqueCourseSuggestionsTitles = [];

  return (
    <>
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell></TableCell>
              <TableCell>Modultitel</TableCell>
              <TableCell>Uni</TableCell>
              <TableCell align="right">User</TableCell>
              <TableCell align="right">Datum</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {courseSuggestionsData?.courseSuggestions?.courseSuggestions?.map(
              (row) => {
                let isDuplicate = false;
                if (
                  latestUniqueCourseSuggestionsTitles.includes(
                    row.title + row.university,
                  )
                ) {
                  isDuplicate = true;
                } else {
                  latestUniqueCourseSuggestionsTitles.push(
                    row.title + row.university,
                  );
                }

                return (
                  <SuggestionTableRow
                    key={row._id}
                    row={row}
                    isDuplicate={isDuplicate}
                  />
                );
              },
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};
